import React, { useState } from 'react';
import {
  StylishInput,
  StylishButton,
  OrderContainer,
  TextWrapper,
  FieldRow,
} from './PurchaseElements';

const CLOUD_FUNCTION_URL =
  'https://us-central1-matinee-c72cb.cloudfunctions.net/createCheckoutSession';

function OrderForm() {
  const [quantity, setQuantity] = useState('');
  const [subtotal, setSubtotal] = useState(0);
  const [totalCost, setTotalCost] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleQuantityChange = (event) => {
    const val = event.target.value;
    setQuantity(val);
    const qty = parseInt(val, 10);
    if (!isNaN(qty) && qty > 0) {
      const sub = qty * 50;
      setSubtotal(sub);
      setTotalCost(sub + 13);
    } else {
      setSubtotal(0);
      setTotalCost(0);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');

    const qty = parseInt(quantity, 10);
    if (isNaN(qty) || qty <= 0) {
      alert('Quantity must be greater than 0.');
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(CLOUD_FUNCTION_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ quantity }),
      });

      const data = await response.json();

      if (!data.ok || !data.url) {
        throw new Error(data.error || 'Failed to create checkout session.');
      }

      window.location.href = data.url;

    } catch (err) {
      console.error('Checkout error:', err);
      setError('Something went wrong. Please try again.');
      setLoading(false);
    }
  };

  return (
    <OrderContainer>
      <h2>Order Matinée Online</h2>
      <TextWrapper>
        Select how many bars you'd like and proceed to checkout.
        Your order will be discreetly shipped to you.
      </TextWrapper>
      
      <br></br>
      

      <form onSubmit={handleSubmit}>
        <FieldRow>
          <label htmlFor="quantity">Number of Bars</label>
          <StylishInput
            type="number"
            id="quantity"
            value={quantity}
            onChange={handleQuantityChange}
            min="1"
            required
          />
        </FieldRow>

        <FieldRow>
          <label htmlFor="subtotal">Subtotal</label>
          <StylishInput type="text" id="subtotal" value={`$${subtotal}`} readOnly />
        </FieldRow>

        <FieldRow>
          <label htmlFor="shipping">Shipping</label>
          <StylishInput type="text" id="shipping" value="$13" readOnly />
        </FieldRow>

        <FieldRow>
          <label htmlFor="totalCost">Total</label>
          <StylishInput type="text" id="totalCost" value={`$${totalCost}`} readOnly />
        </FieldRow>

        {error && <p style={{ color: 'red', fontSize: '13px' }}>{error}</p>}

        <StylishButton type="submit" disabled={loading || !quantity}>
          {loading ? 'Redirecting to checkout...' : 'Proceed to Checkout →'}
        </StylishButton>
      </form>
    </OrderContainer>
  );
}

export default OrderForm;